import React from 'react';
import {connect} from "react-redux";
import OrderDetailComponent from "../components/OrderDetailComponent";
import OrderDetailNotFoundComponent from "../components/OrderDetailNotFoundComponent";
import VouchersNotFoundComponent from "../components/VouchersNotFoundComponent";
import RewardTitleComponent from "../components/RewardTitleComponent";

class OrderDetailContainer extends React.Component {

    componentWillMount() {
        this.props.fetchOrderDetail(this.props.orderId);
    }

    render() {
        if(this.props.orderDetail === null) {
            return this.props.error ? <OrderDetailNotFoundComponent/> : null;
        }

        if(this.props.voucherError === 'VOUCHERS_NOT_FOUND') {
            return <VouchersNotFoundComponent/>
        }

        return (<div>
            <RewardTitleComponent friendlyName={this.props.orderDetail.rewardFriendlyName}/>
            <OrderDetailComponent key={this.props.orderId} orderId={this.props.orderId} voucherAmount={this.props.orderDetail.voucherAmount}
                                  orderedAt={this.props.orderDetail.orderedAt} voucherCodes={this.props.orderDetail.voucherCodes}
                                  rewardClaimedDescription={this.props.rewardClaimedDescription}/>
        </div>);
    }
}

export default connect (
    (state) => {
        return {
            orderDetail: state.orderDetail.item,
            error: state.orderDetail.error,
            rewardClaimedDescription: state.reward.item ? state.reward.item.rewardClaimedDescription : null
        }
    },
    (dispatch) => {
        return {
            fetchOrderDetail: (orderId) => {
                dispatch({
                    type: 'FETCH_ORDER_DETAIL',
                    orderId
                })
            }
        }
    }
) (OrderDetailContainer)